import React, { useState } from 'react';
import '../style/homeservice.css';

// Import video files
import vfxVideo from '../../assets/reels/vfx & hyperlaspe/Gamepar.mp4';
import cgiVideo from '../../assets/reels/cgi/Car Cgi 2.mp4';
import motionVideo from '../../assets/reels/speed ramping/Octa .mp4';
import creativeVideo from '../../assets/reels/industry/Narmin Fac1.mp4';

// Import icons
import { FaFilm, FaCube, FaPlayCircle, FaLightbulb } from 'react-icons/fa';

const HomeService = () => {
  const [hoveredService, setHoveredService] = useState(null);

  const services = [
    {
      id: 1,
      title: "VFX + Hyperlapse Cinematography",
      heading: "Visual Alchemy",
      description: "Intense effects and hyper-speed visuals that transform ordinary footage into cinematic art. We breathe life into your vision with stunning visual effects.",
      video: vfxVideo,
      icon: <FaFilm />
    },
    {
      id: 2,
      title: "CGI & 3D Design",
      heading: "Digital Realms",
      description: "From realistic renders to animated 3D environments, we craft next-level visuals that stand out. Creating worlds beyond imagination.",
      video: cgiVideo,
      icon: <FaCube />
    },
    {
      id: 3,
      title: "Motion Graphics That Move",
      heading: "Kinetic Stories",
      description: "Kinetic typography, brand animations, and infographic videos tailored for social & web. Where motion meets emotion.",
      video: motionVideo,
      icon: <FaPlayCircle />
    },
    {
      id: 4,
      title: "Creative + Strategic Approach",
      heading: "Strategic Vision",
      description: "We mix visuals with marketing insight to craft content that drives engagement and results. Data meets creativity.",
      video: creativeVideo,
      icon: <FaLightbulb />
    }
  ];

  return (
    <section className="services-section">
      <div className="services-container">
        {/* Text Content */}
        <div className="services-content">
          <h2 className="services-heading">What Makes Us Stand Out</h2>
          <h3 className="services-subheading">Key Features of <span className="gradient-text">404 FX Visuals</span></h3>
          <p className="services-description">
            From stunning visual effects to expert edits, we create impactful content that connects, 
            engages, and delivers results across all platforms.
          </p>
        </div>

        {/* Services Grid */}
        <div className="services-grid">
          {services.map((service) => (
            <div
              key={service.id}
              className="service-card"
              onMouseEnter={() => setHoveredService(service.id)}
              onMouseLeave={() => setHoveredService(null)}
            >
              <div className="video-container">
                <video
                  autoPlay
                  muted
                  loop
                  playsInline
                  className="service-video"
                >
                  <source src={service.video} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
                
                {/* Gradient Overlay */}
                <div className="gradient-overlay"></div>
                
                {/* Hover Overlay with Description */}
                <div className="service-overlay">
                  <div className="overlay-content">
                    <h4 className="overlay-heading">{service.heading}</h4>
                    <p className="overlay-description">{service.description}</p>
                    <div className="hover-line"></div>
                  </div>
                </div>

                {/* Service Icon */}
                <div className="service-icon-main">
                  {service.icon}
                </div>
              </div>

              {/* Service Title */}
              <div className="service-info">
                <h4 className="service-title">{service.title}</h4>
                <div className="title-underline"></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HomeService;